export const COLUMNS = [
  { key: 'id', name: '单号' },
];

export const EN_COLUMNS = {
  // expect_begin_at: {
  //   width: 180,
  // },
};

export const localeColumnsAttr = {
  en: EN_COLUMNS,
};
